<template>
  <div class="overview px-2 lg:px-0">

    <div class="overview-1">
      <template v-if="!isMoblie">
        <img class=" absolute -right-2 top-9 w-40" src="@/assets/images/home/round.svg" alt="">
        <img class=" absolute right-40 top-9 w-20" src="@/assets/images/home/round.svg" alt="">
        <img class=" absolute left-9 bottom-9 w-20" src="@/assets/images/home/round.svg" alt="">
      </template>

      <div class="container mx-auto py-28 items-center">
        <div class="flex flex-col lg:px-80">
          <div class="text-main text-4xl text-center font-semibold">{{ overview.title }}</div>
          <div class="text-sub-title text-base text-center pt-8">{{ overview.description }}</div>
          <div class="text-center pt-10">
            <a :href="options.openTradingAccountLink">
              <el-button class="px-2  rounded-lg lg:px-4" type="danger" style="padding: 0.75rem ;">{{
                options.openTradingAccountText
              }}</el-button>
            </a>
            <a :href="options.openDemoAccountLink" class="ml-2">
              <el-button class="px-2 rounded-lg lg:px-4" style="padding: 0.75rem ;">{{ options.openDemoAccountText
                }}</el-button>
            </a>
          </div>
        </div>
        <!-- <img class="m-auto mt-16" src="../../assets/images/account/top2.svg" /> -->
        <img class="m-auto mt-16" :src="$path + overview.openSection?.image?.data?.attributes?.url" />
      </div>
    </div>
    <div class="overview-2">
      <div class="pt-10 container mx-auto flex flex-col h-full">
        <div class="text-main font-semibold text-2xl mb-24">{{ overview.titleSecond }}</div>
        <accountTable :accountFields="overview.openSection?.options?.account_fields_display" />
        <div class="mt-32 notes">
          <p class="text-menu-title font-semibold mt-6">{{ $t('account.overview.overview2.notes') }}</p>
          <p class="text-sub-title mt-4 mb-4 " v-html="overview.notice"></p>
        </div>
      </div>
    </div>
    <div class="overview-3 mt-20">
      <go-register></go-register>
    </div>
    <div class="overview-4 pb-12 pt-20">
      <div class="container mx-auto h-full lg:px-80">
        <div class="font-semibold text-3xl text-main text-center">{{ overview.openSection?.title }}</div>
        <div class="text-sub-title text-base text-center pt-8" v-html="overview.openSection?.description"></div>
      </div>
      <div class="lg:px-40">
        <openAccount :tab="overview.openSection?.tab" />
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
// import $ from 'jquery'
import goRegister from '../global/goRegister'
import { mapGetters } from 'vuex'
import accountTable from './accountTable.vue'
import openAccount from './openAccount.vue'
import { getAccountOverview } from '@/api/account'
export default {
  name: 'Home',
  data() {
    return {
      xsShow: false, // 手机显示
      activeWidth: window.innerWidth,
      overview: {}
    }
  },
  watch: {
    activeWidth: {
      handler(val, oldVal) {
        if (val <= 416) {
          this.xsShow = true
        } else {
          this.xsShow = false
        }
      },
      deep: true, // true 深度监听
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      lang: 'getLang'
    }),
    lang() {
      return this.$store.state.lang
    },
    options() {
      return this.$store.getters.options
    },
    isMoblie() {
      return this.$store.getters.isMoblie
    }
  },
  components: { goRegister, accountTable, openAccount },
  created() {
    this.getAccountOverview()
  },
  mounted() {
  },
  methods: {
    async getAccountOverview() {
      const params = {
        'populate[openSection][populate][tab][fields]': '*',
        'populate[openSection][populate][image][fields]': 'url'
      }
      const result = await getAccountOverview(params)
      this.overview = result.data.attributes
    }
  }
}
</script>

<style lang="less" scoped>
.overview {
  background: #F9FAFB;

  .overview-1 {
    position: relative;
    background-color: #fff;
    background-image: url("../../assets/images/home/advantage.svg");
    // margin-bottom: 30px;
  }

  .overview-2 {
    background: url("../../assets/images/about/bg-test2.svg") no-repeat;
    background-size: cover;

    /deep/ .el-table {
      th {
        background-color: #C1142A;
        color: #fff;
      }
    }
  }

  .overview-4 {
    background-image: url("../../assets/images/home/advantage.svg");

    ul {
      li {
        list-style-type: disc;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .overview {
    .notes {
      margin-top: 0;
    }
  }
}
</style>
